var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Title',{attrs:{"title":"Build and Deployment How To"}}),_c('v-card',{staticClass:"mx-auto mt-5",attrs:{"tile":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }